import types from 'store/types/global';

export default {
  setCollapsed: (collapsed) => async (dispatch) => {
    return dispatch({
      type: types.GLOBAL_SET,
      key: 'collapsed',
      data: collapsed,
    });
  },
};
